'use client'

import { MAPTILER_API_TOKEN } from '@components/app/LocationMap/consts'
import { classMerge } from '@components/utilities/classMerge'
import DynamicRoutes from '@lib/routes/DynamicRoutes'
import ExternalRoutes from '@lib/routes/ExternalRoutes'
import { getLocationFromLatLngStrings } from '@lib/utilities/geo/getLocationFromLatLngStrings'
import type { HospitalPageData } from '@modules/hospitals/cache/getCachedHospitalPageData'
import maplibregl from 'maplibre-gl' // Using MapLibre alt: http://visgl.github.io/react-map-gl/docs/get-started/get-started#using-with-a-mapbox-gl-fork
import 'maplibre-gl/dist/maplibre-gl.css'
import Link from 'next/link'
import { useState } from 'react'
import { NavigationControl, Map as ReactMap } from 'react-map-gl/dist/es5'
import { HospitalLocationPin } from './HospitalLocationPin.client'

interface HospitalLocationMapProps {
  hospitals: HospitalPageData['similarHospitalsNearby']
  hoveredHospitalSlug?: string
  nearestPoint: { lat: string; lng: string }
  setHoveredHospitalSlug: (slug?: string) => void
}

export default function HospitalMap({
  hospitals,
  hoveredHospitalSlug,
  nearestPoint,
  setHoveredHospitalSlug,
}: HospitalLocationMapProps) {
  const { latitude, longitude } = getLocationFromLatLngStrings(nearestPoint)

  const [mapPositionState, setMapPositionState] = useState<{
    latitude: number
    longitude: number
    zoom?: number
  }>({
    latitude,
    longitude,
    zoom: 9,
  })

  return (
    <div className='flex w-full flex-wrap-reverse overflow-hidden border-y border-neutral200'>
      <div className={classMerge('w-full', 'h-72 md:h-[545px]')}>
        <ReactMap
          {...mapPositionState}
          attributionControl={false}
          mapLib={maplibregl}
          mapStyle={ExternalRoutes.mapTilerStyleUrl(MAPTILER_API_TOKEN)}
          onMove={(evt) => setMapPositionState(evt.viewState)}
          style={{ height: '100%', width: '100%' }}
        >
          <NavigationControl />
          {hospitals
            // .filter((doctor) => doctor.geolocation)
            .map((hospital) => (
              <Link
                href={DynamicRoutes.center(hospital.slug)}
                key={hospital.slug}
              >
                <HospitalLocationPin
                  highlighted={hospital.slug === hoveredHospitalSlug}
                  hospital={hospital}
                  onMouseEnter={() => {
                    setHoveredHospitalSlug(hospital.slug)
                  }}
                  onMouseLeave={() => {
                    setHoveredHospitalSlug(undefined)
                  }}
                />
              </Link>
            ))}
        </ReactMap>
      </div>
    </div>
  )
}
